import type React from 'react';

import { observer } from 'mobx-react';

import DescriptionItem from './controls/item';
import type { IProps as IDescriptionItemProps } from './controls/item';
import DescriptionNested from './controls/nested';
import type { IProps as IDescriptionNestedProps } from './controls/nested';

export interface IProps extends IDescriptionItemProps, IDescriptionNestedProps {
  isMenu?: boolean;
}

const Description: React.FC<IProps> = observer(({ isMenu, open, description, onClick }) => {
  return !!isMenu ? (
    <DescriptionNested description={description} open={open} onClick={onClick} />
  ) : (
    <DescriptionItem description={description} />
  );
});

Description.displayName = 'Description';

export default Description;
